import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { base_url, config } from '../utils/axiosConfig';
import { Link } from 'react-router-dom';
import { BsLinkedin, BsGithub, BsInstagram, BsYoutube } from 'react-icons/bs';
import { BiLogoPlayStore } from "react-icons/bi";
import AppQR from '../images/AppQR.jpeg';
import logoImg from '../images/shaka-removebg-preview.png';

const Footer = () => {
  const [contact, setContact] = useState({});

  useEffect(() => {
    const fetchContact = async () => {
      try {
        const res = await axios.get(`${base_url}master/getcontact`, config);
        if (Array.isArray(res.data) && res.data.length > 0) {
          setContact(res.data[0]);
        }
      } catch (err) {
        console.error("Failed to load contact info", err);
      }
    };
    fetchContact();
  }, []);

  return (
    <>
      {/* Newsletter Section */}
      <footer className="py-2 bg-dark text-white w-100">
        <div className="px-2">
          <div className="row justify-content-left g-3">
            <div className="col-12 col-md-10">
              <div className="d-flex flex-column flex-md-row align-items-center gap-3 text-center text-md-start">
                <img
                  src={logoImg}
                  alt="newsletter"
                  className="img-fluid"
                  style={{ maxWidth: '80px' }}
                />
                <h2 className="mb-0 fs-4">
                  Where blessings meet choices – shop with heart, receive with grace.
                </h2>
              </div>
            </div>
          </div>
        </div>
      </footer>


      {/* Contact & Links Section */}
      <footer className="py-4 bg-dark text-white">
        <div className="container-xxl">
          <div className="row row-cols-2 row-cols-md-4 g-4">
            {/* Contact Us */}
            <div>
              <h5>Contact Us</h5>
              <address className="text-white-50 mb-2 mt-3" style={{ fontSize: '14px', lineHeight: '1.5' }}>
                {contact.addres || 'Address'}
              </address>
              <a href={`tel:${contact.number || ''}`} className="d-block mb-1 text-white-50 text-decoration-none" style={{ fontSize: '14px' }}>
                {contact.number || '+91 8925220366'}
              </a>
              <a href={`mailto:${contact.email || ''}`} className="d-block mb-3 text-white-50 text-decoration-none" style={{ fontSize: '14px' }}>
                {contact.email || 'demo@gmail.com'}
              </a>
              <div className="d-flex gap-3">
                <a className="text-white" href="#"><BsLinkedin className="fs-5" /></a>
                <a className="text-white" href="#"><BsGithub className="fs-5" /></a>
                <a className="text-white" href="#"><BsInstagram className="fs-5" /></a>
                <a className="text-white" href="#"><BsYoutube className="fs-5" /></a>
              </div>
            </div>

            {/* Information */}
            <div>
              <h5>Information</h5>
              <div className="d-flex flex-column">
                <Link to="/privacy-policy" className="text-white-50 text-decoration-none mb-1">Privacy Policy</Link>
                <Link to="/Cancellation-Refunds" className="text-white-50 text-decoration-none mb-1">Cancellation & Refunds</Link>
                <Link to="/shipping-policy" className="text-white-50 text-decoration-none mb-1">Shipping Policy</Link>
                <Link to="/terms-conditions" className="text-white-50 text-decoration-none mb-1">Terms & Conditions</Link>
              </div>
            </div>

            {/* Account */}
            <div>
              <h5>Account</h5>
              <div className="d-flex flex-column">
                <Link to="/about" className="text-white-50 text-decoration-none mb-1">About Us</Link>
                <Link to="/contact" className="text-white-50 text-decoration-none mb-1">Contact</Link>
              </div>

            </div>

            {/* Quick Links */}
            <div>
              <h5 className="mb-3">Quick Links</h5>

              <div className="d-flex flex-column mb-3">
                <Link
                  to="/product"
                  className="text-white-50 text-decoration-none mb-1"
                >
                  Products
                </Link>
              </div>

              <div>
                <h6 className="mb-2">Download Our App</h6>

                <div className="d-flex flex-column gap-2">
                 <a
  href="https://play.google.com/store/apps/details?id=com.vivekasoftek.ecommerce"
  className="text-white-50 text-decoration-none playstore-link"
  target="_blank"
  rel="noopener noreferrer"
>
  <BiLogoPlayStore /> Get it on Play Store
</a>

                  <img
                    src={AppQR}
                    alt="Download Our App"
                    style={{
                      width: "120px",
                      height: "120px",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>



            </div>
          </div>
        </div>
      </footer>

      {/* Bottom Footer */}
      <footer className="py-3 bg-dark text-white-50 border-top border-secondary">
        <div className="container-xxl">
          <div className="text-center">
            <small>
              &copy; {new Date().getFullYear()} <a href='https://vivekasoftek.com/' target="_blank" rel="noopener noreferrer" className="text-white-50 text-decoration-none">Vivekasoftek</a>. All Rights Reserved.
            </small>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
